import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { logout } from "../../api/helper";
import { withTranslation } from "react-i18next";
import "./InsMenu.scss";
// import images from "../../ressources/images";
// import { setLocale } from "../../store/actions/authActions";
// import { connect } from "react-redux";
// import i18next from "i18next";
import { getLocales } from "../../api/splashscreen";
import { setLocale } from "../../store/actions/authActions";
import { connect } from "react-redux";
import { clearCart } from "../../api/shop";
import ConfirmCartWipeModal from "../Shop/Cart/ConfirmCartWipeModal";
import { createIndexDB } from "../../utils/indexDb_Helper";
// import { appi18n } from "../../translations/translations";
import * as microsoftTeams from "@microsoft/teams-js";
import "/node_modules/flag-icons/css/flag-icons.min.css";

export class InsMenu extends Component {
  static propTypes = {
    open: PropTypes.bool,
  };

  constructor(props) {
    super(props);
    this.sideMenuClosing = React.createRef();
    this.state = {
      selectingLocale: false,
      languages: [],
      currentLocale: null,
      closeMenu: false,
      cart: {},
      askForConfirmation: false,
      currentAskedLocale: null,
      isTeams: false,
    };
  }

  componentDidMount() {
    this.setState({ cart: this.props.cart });
    this._getLocales();
    microsoftTeams.initialize(() => {
      this.setState({ isTeams: true });
    });
  }

  _getLocales() {
    getLocales()
      .then((languages) => {
        this.getCurrentLanguage(languages);
        this.setState({ languages });
      })
      .catch((err) => console.log(err));
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.i18n.language !== this.state.currentLocale?.locale) {
      this.getCurrentLanguage(this.state.languages);
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.cart !== this.props.cart) {
      this.setState({ cart: this.props.cart });
    }
  }

  getCurrentLanguage(languages) {
    // On cherche le language + pays exact
    let currentLanguage = languages.find(
      (language) =>
        language.locale === this.props.i18n.language.replace(/-/g, "_")
    );

    // Si on n'a pas trouvé le langage + pays exact, on cherche le langage tout court
    if (!currentLanguage) {
      currentLanguage = languages.find(
        (language) =>
          language.locale === this.props.i18n.language.substring(0, 2)
      );
    }

    if (!currentLanguage) {
      currentLanguage = languages[0];
    }

    this.setState({ currentLocale: currentLanguage });
  }

  _logout = () => {
    logout();
    createIndexDB();
    if (navigator?.clearAppBadge) {
      navigator.clearAppBadge();
    }
  };

  shouldPreventUser = () => {
    return this.props.cart.elements
      ? this.props.cart.elements.length > 0
      : false;
  };

  tryChangingLocale = (locale) => {
    if (this.props.i18n.language !== locale.locale.replace(/_/g, "-")) {
      if (!this.shouldPreventUser()) {
        this.changeLocale(locale);
      } else {
        this.setState({ askForConfirmation: true, currentAskedLocale: locale });
      }
    }
  };

  changeLocale = (locale) => {
    // Pour l'instant on décide de vider le panier à chaque changement de langue
    // On "évite" ainsi tous bug possibles avec des produits qui seraient stockés dans le panier mais invisible aux retours API

    clearCart()
      // Le panier de la boutique se rafraîchit une fois la langue changée, donc on préfère changer la langue une fois le panier vidé à 100%
      .then((res) => {
        // this.props.setLocale(locale.locale.replace(/_/g, "-"));
        this.props.i18n.changeLanguage(locale.locale.replace(/_/g, "-"));
        this._getLocales();
      })
      .catch((err) => {
        // On reçoit une 404 quand le panier est vide :zzz: donc pour l'instant on change la langue même s'il y a une erreur
        // this.props.setLocale(locale.locale.replace(/_/g, "-"));
        this.props.i18n.changeLanguage(locale.locale.replace(/_/g, "-"));
        this._getLocales();
      });

    this.closeSelectingLocale();
  };

  closeMenu = () => {
    // this.setState({closeMenu: !this.state.closeMenu})
    this.props.close();
    this.sideMenuClosing.current.className += "close";
  };

  openSelectingLocale = () => this.setState({ selectingLocale: true });

  closeSelectingLocale = () => this.setState({ selectingLocale: false });

  closeConfirmation = () => this.setState({ askForConfirmation: false });

  continueConfirmation = (locale) => {
    this.closeConfirmation();
    this.changeLocale(locale);
  };

  render() {
    const LocaleSwitch = ({ locale }) => (
      <li onClick={() => this.tryChangingLocale(locale)}>
        <span className={`flag`}><span className={`fi fi-${locale?.region.toLowerCase()} `}></span></span> {locale.name}
      </li>
    );

    const { sap, open, t, hideMyOrders, config, account } = this.props;
    const {
      selectingLocale,
      languages,
      currentLocale,
      askForConfirmation,
      isTeams,
    } = this.state;
    const isOpen = open ? "open " : "close ";
    const className = "sidemenu " + isOpen;

    return (
      <>
        {askForConfirmation && (
          <ConfirmCartWipeModal
            close={this.closeConfirmation}
            submit={() =>
              this.continueConfirmation(this.state.currentAskedLocale)
            }
          />
        )}
        <div className={"menu-background " + isOpen} onClick={this.closeMenu} />
        <div ref={this.sideMenuClosing} className={className}>
          <div className="side-menu--wrapper">
            <div className="menu2" onClick={this.closeMenu}>
              <div className="menu--line2"></div>
              <div className="menu--line2"></div>
              <div className="menu--line2"></div>
            </div>
            <div className="menu3" onClick={this.closeMenu}>
              <div className="menu--line3"></div>
              <div className="menu--line3"></div>
              <div className="menu--line3"></div>
            </div>
          </div>
          {selectingLocale ? null : (
            <ul>
              {isTeams && (
                <div className="menu-links">
                  <li onClick={this.closeMenu} className="menu-link ins_home">
                    <Link to="/">home</Link>
                  </li>

                  {config.features.brands_enabled ? (
                    <li
                      onClick={this.closeMenu}
                      className="menu-link ins_brands"
                    >
                      <Link to="/brands">{t("brands")}</Link>
                    </li>
                  ) : null}
                  {/* <li
                    onClick={this.closeMenu}
                    className="menu-link ins_formations"
                  >
                    <Link to="/formations">{t("formations")}</Link>
                  </li> */}
                  {config.shopEnabled && account.validated ? (
                    <li onClick={this.closeMenu} className="menu-link ins_shop">
                      <Link to="/shop">{t("shop")}</Link>
                    </li>
                  ) : null}
                  {config.features.social_wall_enabled && account.validated ? (
                    <li onClick={this.closeMenu} className="menu-link ins_wall">
                      <Link to="/wall">{t("wall")}</Link>
                    </li>
                  ) : null}

                  <li onClick={this.closeMenu} className="menu-link ins_search">
                    <Link to="/search">{t("search")}</Link>
                  </li>
                </div>
              )}

              <li onClick={this.closeMenu}>
                <Link to="/profile">{t("acces_to_account")}</Link>
              </li>
              <li onClick={this.closeMenu}>
                <Link to="/profile/groups">{t("my_groups")}</Link>
              </li>
              {sap && !hideMyOrders && (
                <>
                  <li onClick={this.closeMenu}>
                    <Link to="/profile/orders">{t("my_orders")}</Link>
                  </li>
                  {/* <li onClick={this.closeMenu}>
                    <Link to="/parrainage">{t("sponsorship")}</Link>
                    <img src={images.icon_sponsorship} alt="" />
                  </li> */}
                </>
              )}
              {!isTeams && (
                <li onClick={this.closeMenu}>
                  <Link to="/contact">{t("contact")}</Link>
                </li>
              )}
              {!isTeams && <li onClick={this._logout}>{t("disconnection")}</li>}
              <li
                onClick={() => this.openSelectingLocale()}
                className="outline"
              >
                <span className={`flag`}><span className={`fi fi-${currentLocale?.region.toLowerCase()} `}></span></span>{" "}
                {currentLocale?.name} <i className="chevron-right"></i>
              </li>
            </ul>
          )}
          {selectingLocale ? (
            <ul>
              <li onClick={() => this.closeSelectingLocale()}>{t("return")}</li>
              {languages.map((language) => (
                <LocaleSwitch
                  key={language.locale}
                  locale={language}
                  label="Label"
                />
              ))}
            </ul>
          ) : null}
        </div>
      </>
    );
  }
}

//extract data from the redux store
const mapStateToProps = (state) => ({
  cart: state.store.cart,
  config: state.config,
  account: state.account,
});

// Le tableau est modifié on le modifie dans le store
const mapDispatchToProps = (dispatch) => {
  return {
    setLocale: (locale) => {
      dispatch(setLocale(locale));
    },
  };
};

export default withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(InsMenu)
);
